import React from 'react';

import { Icon } from 'semantic-ui-react';

export default class Modal extends React.Component {
  render() {
    const {
      title, children, closeButton, confirmButton, onClose, customConfirm, cancelButton, noConfirm, titleStyle,
      buttonsStyle, cancelEnabled = true, size = 'large', id
    } = this.props;

    return (
      <div className="modal-background">
        <div className={`modal ${size}`} id={id}>
          <div className="modal-header" style={titleStyle}>
            <h3>{title}</h3>

            {closeButton && <Icon onClick={onClose} className="times" />}
          </div>

          <div className="modal-content">
            {children}
          </div>

          <div className="modal-buttons" style={buttonsStyle}>
            {cancelEnabled && <button className="transparent" type="button" onClick={onClose} {...cancelButton}>{cancelButton?.text || 'Cancelar'}</button>}

            {!noConfirm && (customConfirm || <button type="button" {...confirmButton}>{confirmButton.text}</button>)}
          </div>
        </div>
      </div>
    );
  }
}
